import * as React from 'react';

import {ConfigurationCheckbox} from './configuration-checkbox';
import type {
    Configuration,
    GroupConfiguration,
    GroupConfigurationSetting,
} from './group-configuration-table';

import styles from './group-configurations-column.module.css';

type Props = {
    configurations: Configuration[];
    header: React.ReactNode;
    groupConfiguration?: GroupConfiguration;
    onGroupConfigurationChange?: (
        configurationId: string,
        groupConfigurationId: string,
        checked: boolean
    ) => any;
    isUpdating?: boolean;
};

export function GroupConfigurationsColumn(props: Props) {
    const {configurations, header, groupConfiguration, onGroupConfigurationChange, isUpdating} =
        props;

    return (
        <div
            key={groupConfiguration ? groupConfiguration.id : 'create-new-group'}
            className={
                groupConfiguration && groupConfiguration.isFixed
                    ? styles['group-configurations-column--fixed']
                    : styles['group-configurations-column']
            }
        >
            <div className={styles['group-configurations-column-cell']}>{header}</div>
            {configurations.map((configuration: Configuration) => (
                <div
                    key={`${groupConfiguration ? groupConfiguration.id : 'create-new'}-${
                        configuration.id
                    }`}
                    className={styles['group-configurations-column-cell']}
                >
                    {groupConfiguration && onGroupConfigurationChange ? (
                        <ConfigurationCheckbox
                            groupConfigurationSetting={groupConfiguration.configurations.find(
                                (configurationSetting: GroupConfigurationSetting) =>
                                    configuration.id === configurationSetting.id
                            )}
                            onChange={(checked) => {
                                onGroupConfigurationChange(
                                    configuration.id,
                                    groupConfiguration.id,
                                    checked
                                );
                            }}
                            isFixed={groupConfiguration.isFixed || isUpdating}
                        />
                    ) : (
                        <div />
                    )}
                </div>
            ))}
        </div>
    );
}
